import { Link } from 'react-router-dom';

const CTASection = () => {
  return (
    <section className="py-32 bg-gradient-to-br from-primary via-[#4A2C7F] to-dark relative overflow-hidden">
      {/* Floating Geometric Shapes */}
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute top-20 left-20 w-64 h-64 bg-secondary/10 rounded-full blur-3xl animate-pulse"></div>
        <div className="absolute bottom-20 right-20 w-96 h-96 bg-accent/10 rounded-full blur-3xl animate-pulse" style={{ animationDelay: '1s' }}></div>
        <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-[500px] h-[500px] border border-white/10 rounded-full"></div>
      </div>

      <div className="max-w-6xl mx-auto px-6 relative z-10">
        {/* Visual Element */}
        <div className="mb-16">
          <div className="relative h-96 rounded-3xl overflow-hidden">
            <img
              src="https://readdy.ai/api/search-image?query=abstract%203D%20render%20visualization%20of%20interconnected%20glowing%20network%20nodes%20and%20flowing%20data%20streams%20with%20holographic%20elements%20representing%20digital%20connectivity%20and%20business%20growth%20in%20vibrant%20purple%20cyan%20and%20orange%20neon%20colors%20against%20dark%20gradient%20background%20with%20futuristic%20technology%20aesthetic&width=1200&height=600&seq=cta1&orientation=landscape"
              alt="Digital Growth Network Visualization"
              className="w-full h-full object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-primary/60 to-transparent"></div>
          </div>
        </div>

        {/* Text Content */}
        <div className="text-center space-y-8">
          <h2 className="text-5xl font-serif text-white leading-tight max-w-4xl mx-auto">
            Ready to accelerate your <span className="italic font-light">growth</span> and achieve unprecedented <span className="italic font-light">success</span> in the digital landscape?
          </h2>

          <Link
            to="/enquiry"
            className="inline-block px-12 py-5 bg-dark text-white font-semibold rounded-full hover:bg-white hover:text-dark transition-all duration-300 shadow-2xl hover:shadow-white/20 hover:scale-105 text-lg whitespace-nowrap"
          >
            Let's Talk Growth
          </Link>
        </div>
      </div>
    </section>
  );
};

export default CTASection;
